import ErrorIcon from '@material-ui/icons/Error';

import CodigoRechazoCreate from './CodigoRechazoCreate';
import CodigoRechazoList from './CodigoRechazoList';
import CodigoRechazoShow from './CodigoRechazoShow';
import CodigoRechazoEdit from './CodigoRechazoEdit';

const indexCodigoRechazo = {
    icon: ErrorIcon,
    list: CodigoRechazoList,
    create: CodigoRechazoCreate,
    edit: CodigoRechazoEdit,
    show: CodigoRechazoShow,
};

export default indexCodigoRechazo;
